<template>
    <div class="page-content-wrapper">
        <div class="content">
            <div class="container-fluid container-fixed-lg">
                <div class="row">
                    <div class="col-lg-4 m-b-10">
                        <div class="card no-border widget-loader-circle no-padding rounded h-100">
                            <div class="card-header"
                                 :class="getShiftClass.box[0]">
                            </div>
                            <div class="card-body p-t-20 p-b-30">
                                <div class="d-flex align-items-center">
                                    <div class="card-icon">
                                        <img v-if="getTips[objIndex].Image"
                                             :src="require(`@/assets/img/Food icons/${getTips[objIndex].Image}`)"
                                             width="100">
                                    </div>
                                    <div class="card-link">
                                        <a class="card-link-24"
                                           :class="getShiftClass.td[0]"
                                           href="#">{{ getTips[objIndex].Title }}</a>
                                    </div>
                                </div>
                                <div class="p-t-15">
                                  <span v-html="getTips[objIndex].Text"></span>
                                  <div class="p-t-25 d-block">
                                      <router-link class="nextbutton bg-24 text-white d-block"
                                                   :to="{ name: 'tips'}">
                                          {{ $t('survey_back') }}
                                      </router-link>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['tip_id'],
  computed: {
    ...mapGetters([
      'getShiftClass',
      'getTips',
    ]),
    objIndex() {
      return this.getTips.findIndex((obj => obj.Id === this.tip_id))
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/TipsPage.vue